import * as React from 'react';
import { FavouriteRow } from '../types';

export const renderTableHeader = (row: FavouriteRow, hideAggregateColumns: boolean, compactView: boolean) => {
  return <thead>
    <tr>
      {row.selectionValues.map((f, i) => <th className={f.columnType} key={i}>
        {f.label}
      </th>)}
      {!!row.aggregateValue && <th className={row.aggregateValue.columnType}>
        {row.aggregateValue.label}
      </th>}
      {!hideAggregateColumns && !!row.subValue && <th className={row.subValue.columnType}>
        {row.subValue.label}
      </th>}
      {!hideAggregateColumns && !!row.rollingAvarage && <th className={!compactView && row.rollingAvarage.columnType}>
        {row.rollingAvarage.label}
      </th>}
      {!hideAggregateColumns && !!row.target && <th className={!compactView && row.target.columnType}>
        {row.target.label}
      </th>}
    </tr>
  </thead>;
};
